<template>
  <div class="modal fade" id="countryUpdateModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered w-[700px]">
      <div class="modal-content" v-if="local">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Update Country</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="overflow-hidden">
            <div class="float-left w-1/2 px-5 h-20 modal-item">
              ID:
              <v-text-field v-model="local.id" variant="outlined" density="compact" readonly></v-text-field>
            </div>
            <div class="float-left w-1/2 px-5 h-20 modal-item">
              Order:
              <v-text-field v-model="local.order" type="number" variant="outlined" density="compact"></v-text-field>
            </div>
            <div class="float-left w-full px-5 h-20 modal-item">
              Country Name:
              <v-text-field v-model="local.name" variant="outlined" density="compact"></v-text-field>
            </div>
            <div class="float-left w-full px-5 h-20 modal-item">
              Flag URL (iconurl):
              <v-text-field v-model="local.iconurl" variant="outlined" density="compact"></v-text-field>
            </div>
            <div class="float-left w-full px-5 h-14 modal-item flex items-center">
              Sellable:
              <v-switch class="ml-4" v-model="local.sellable" color="success"></v-switch>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" :disabled="buttonDisableFlag" class="btn btn-primary" @click="handleUpdate">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from "vue";
import { useAdminCountryStore } from "@/stores";

const props = defineProps({
  item: { type: Object, default: null },
});
const emit = defineEmits(["updated"]);

const adminCountryStore = useAdminCountryStore();
const buttonDisableFlag = ref(false);
const local = ref(null);

watch(
  () => props.item,
  (v) => {
    local.value = v ? { ...v } : null;
  },
  { immediate: true }
);

const handleUpdate = async () => {
  if (!local.value) return;
  buttonDisableFlag.value = true;
  await adminCountryStore.updateCountry({
    id: local.value.id,
    name: local.value.name,
    iconurl: local.value.iconurl,
    sellable: !!local.value.sellable,
    order: Number(local.value.order) || 0,
  });
  buttonDisableFlag.value = false;
  emit("updated");
};
</script>

